// UUID validation regex (supports general UUID format)
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Validates if a value is a valid UUID format.
 * @param {unknown} value - The value to validate
 * @returns {boolean} True if the value is a valid UUID string
 */
export const isValidUUID = (value) => (
  typeof value === 'string' && UUID_REGEX.test(value)
)

/**
 * True when `v` looks like a GraphQL-style UUID (non-empty string, length ≥ 32 after trim, valid UUID format).
 * Exported for components that need to match dashboard invitee route id heuristics (e.g. avoid duplicate RTK fetches).
 * @param {unknown} v
 * @returns {boolean}
 */
export const isUuidLike = (v) => (
  v != null && v !== '' && String(v).length >= 32 && isValidUUID(String(v).trim())
)
